import React, { FC, memo } from 'react';
import { PaginationProps } from '@material-ui/lab/Pagination';
import styled from 'styled-components';

import { Pagination as UIPagination } from './pagination.styles';

const S = {

  StyledPagingation: styled(UIPagination) `
  ${({ theme: { breakpoints, colors } }) => ` 
  
  ${breakpoints.down('sm')} {
    button {  width: auto !important;}


  ` }


  `

}

export const Pagination: FC<PaginationProps> = memo((props) => {
  if (props.count === 1) {
    return null;
  }

  return (

    <S.StyledPagingation
      size="large"
      variant="text"
      shape="rounded"
      color="primary"
      {...props}
    />
  );
});
